import { TrackPayload, UserIdentifier } from '../types';

export const ANALYTICS = 'ANALYTICS';
export const STORE_USER_IDENTIFIER_FOR_ANALYTICS =
  'IDENTIFY_USER_FOR_ANALYTICS';

export const Track = (payload: TrackPayload) => ({
  type: ANALYTICS,
  payload,
});

export const StoreUserIdentifier = (payload: UserIdentifier) => ({
  type: STORE_USER_IDENTIFIER_FOR_ANALYTICS,
  payload,
});
try {
    // @ts-ignore
    Track.displayName = "Track";
    // @ts-ignore
    Track.__docgenInfo = { "description": "", "displayName": "Track", "props": { "event": { "defaultValue": null, "description": "", "name": "event", "required": true, "type": { "name": "string" } }, "params": { "defaultValue": null, "description": "", "name": "params", "required": false, "type": { "name": "{}" } }, "vendor": { "defaultValue": null, "description": "", "name": "vendor", "required": false, "type": { "name": "TrackingVendor" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/analyticsManager/actions/analyticsManager.actions.ts#Track"] = { docgenInfo: Track.__docgenInfo, name: "Track", path: "src/shared/analyticsManager/actions/analyticsManager.actions.ts#Track" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    StoreUserIdentifier.displayName = "StoreUserIdentifier";
    // @ts-ignore
    StoreUserIdentifier.__docgenInfo = { "description": "", "displayName": "StoreUserIdentifier", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/analyticsManager/actions/analyticsManager.actions.ts#StoreUserIdentifier"] = { docgenInfo: StoreUserIdentifier.__docgenInfo, name: "StoreUserIdentifier", path: "src/shared/analyticsManager/actions/analyticsManager.actions.ts#StoreUserIdentifier" };
}
catch (__react_docgen_typescript_loader_error) { }